import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CART_ITEM from '../../../../../services/checkout/constants/cartItems';
import { getPhotoPricingPrintProduct } from '../../../../../services/checkout/redux/helpers';
import { getGroupedPhotoPricingPrintProducts } from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/IndividualPrintsOption/helpers';
import PrintProductsGroup from '../PrintProductsGroup';

const propTypes = {
  activeIdentity: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  selectedIdentity: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    prepaid_photo_print_packages_enabled: PropTypes.bool,
  }).isRequired,
  photoPricing: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onPhotoPricingPrintProductToggle: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
};

const PhotoPricingItemsSelector = ({
  activeIdentity,
  selectedIdentity,
  albumFolder,
  photoPricing,
  onPhotoPricingPrintProductToggle,
  cart,
}) => {
  if (!photoPricing || !albumFolder?.prepaid_photo_pricings_enabled) {
    return null;
  }

  const albumPrintPackageCartItems = cart.filter(item =>
    [CART_ITEM.ALBUM_PRINT_PACKAGE, CART_ITEM.PURCHASED_PRINT_PACKAGE].includes(
      item.type,
    ),
  );
  const hasPrintPackageCartItems = albumPrintPackageCartItems.length > 0;
  const canPurchasePhotoPrintItems =
    !photoPricing?.requires_package_purchase || hasPrintPackageCartItems;

  const photoPricingPrintProducts =
    photoPricing?.print_product_items?.records ?? [];
  const groupedPrintProducts = getGroupedPhotoPricingPrintProducts(
    photoPricingPrintProducts,
  );

  return (
    <Fragment>
      <h4 className="mt-2">Individual Prints &amp; Products</h4>

      {photoPricing?.print_product_items?.records?.length > 0 && (
        <PrintProductsGroup
          printProducts={groupedPrintProducts}
          getPrintProductSizePrice={(printProduct, printProductSize) => {
            return photoPricingPrintProducts.find(
              photoPricingPrintProduct =>
                photoPricingPrintProduct.print_product.id === printProduct.id &&
                photoPricingPrintProduct.print_product_size.id ===
                  printProductSize.id,
            )?.price;
          }}
          onCartItemToggle={({ printProduct, printProductSize }) =>
            onPhotoPricingPrintProductToggle({
              identity: activeIdentity,
              album: selectedIdentity?.album_membership?.album,
              albumFolder,
              photoPricingPrintProduct: photoPricingPrintProducts.find(
                photoPricingPrintProduct =>
                  photoPricingPrintProduct.print_product.id ===
                    printProduct.id &&
                  photoPricingPrintProduct.print_product_size.id ===
                    printProductSize.id,
              ),
              photoPricing,
              prePaid: true,
            })
          }
          getCartItem={({ printProductId, printProductSizeId }) =>
            getPhotoPricingPrintProduct(cart, {
              photoPricingPrintProductId: photoPricingPrintProducts.find(
                photoPricingPrintProduct =>
                  photoPricingPrintProduct.print_product.id ===
                    printProductId &&
                  photoPricingPrintProduct.print_product_size.id ===
                    printProductSizeId,
              )?.id,
              identityId: activeIdentity?.id,
              prePaid: true,
            })
          }
          disabled={!canPurchasePhotoPrintItems}
          disabledElement={
            <span className="purchasing-option-item-info-requires-package">
              Requires the purchase of a print package first.
            </span>
          }
        />
      )}
    </Fragment>
  );
};

PhotoPricingItemsSelector.propTypes = propTypes;

export default PhotoPricingItemsSelector;
